import React from 'react';
import { ScaleLoader } from 'react-spinners';
import { Route } from 'react-router-dom';
import TsSprintItem from './TsSprintItem.jsx';
import TsSprintDetail from './TsSprintDetail.jsx';

class TsSprintList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			sprintsInfo: false,
			teamInfo: {
				developpersInfo: false,
				testersInfo: false,
				subTestersInfo: false,
			},
			developpersId: {
				'58ef4ba73bd70398c92a2b18': false, // Robin
				'59fb12f7fe50de52f15b4ef8': true, // Alexis
				'59fb13885dd4ab2553479720': true, // Florian
				'543f79263da47272f507b7f4': true, // Baptiste L
				'5530c04cf33959424e9c4e40': true, // Antoine
				'59008163d58d18725b216c93': true, // Anthony
			},
			testersId: {
				'4fb630e7d7c3640f18274d35': true, // Baptiste B
				'4fb6350a2b10e200092f2ca1': true, // Maxime
				'54e4a19481e589e9d1510aa6': true, // Hadrien
				'59fc70775058b71ef05d4bbf': true, // Camille
				'5584401c852c37c6293e859e': false, // Nicolas
				'5900992ee7ab2e4f2449b0bb': true, // Julie
			},
			subTestersId: {
				'5a01765e98769493a0557687': {
					show: true,
					parentTester: '5900992ee7ab2e4f2449b0bb', // Hugo > Julie
				},
				'56a103701885d3b01f69ab3e': {
					show: true,
					parentTester: '54e4a19481e589e9d1510aa6', // Elise > Hadrien
				},
				'59fb19466ed69c72b3ed0cf2': {
					show: true,
					parentTester: '5900992ee7ab2e4f2449b0bb', // Ladj > Julie
				},
				'59bacca7b2937b7a2a5f8b64': {
					show: true,
					parentTester: '5584401c852c37c6293e859e', // Marie H > Nicolas
				},
			},
		};
	}

	// Si le composant va être utilisé
	componentWillMount() {
		// On appelle la fonction pour update la liste
		this.updateSprintsInfoFromBoardAPI(this.updateSprintsInfoState, this);

		// On appelle la fonction pour update la team
		this.updateTeamInfoFromBoardAPI(this.updateTeamInfoState, this);
	}

	// Permet de mettre à jour le State streamersInfo
	updateSprintsInfoState(data, elem) {
		elem.setState({
			loading: false,
			sprintsInfo: data,
		});
	}

	// Permet de mettre à jour le State teamInfo
	updateTeamInfoState(data, elem) {
		elem.setState({
			teamInfo: data,
		});
	}

	// Fonction permettant de mettre à jour les infos de streamer
	updateSprintsInfoFromBoardAPI(callback, elem) {
		// On lance la requête pour récupérer les infos des streamers depuis leur pseudo
		fetch(
			'https://api.trello.com/1/boards/RzH18HsB/lists?key=e0edc2f7a3f1efc4115084c573964b8c&token=6392d59c2cfbb640baeb86ff97cd20a4d39c38149cde8050638ec8fae7cd75eb&cards=open&card_fields=id,name&filter=open&fields=id,name',
			{
				methode: 'GET'
			}
		)
		.then(results => {
			return results.json();
		})
		.then(data => {
			// On instancie un objet qui va contenir les informations de la liste
			let objListsAPI = {};

			// On instancie un compteur
			let sprintOrder = 1;

			// On parcourt le tableau de sprints du board
			data.map((listAPI) => {
				// On récupère le nom de la liste
				const listAPIName = listAPI.name;

				// On vérifie si le nom de la liste commence par Archive
				const isListArchive = listAPIName.match(/^Archive/g);

				// Si le nom de la liste est une archive
				if (isListArchive !== null) {
					// On récupère le numéro du Sprint
					const sprintNumber = /Sprint (.+) -/.exec(listAPIName)[1];

					// On récupère le nom du Sprint
					const sprintName = listAPIName.substr(10);

					// On récupère la version du Sprint
					const sprintVersion = listAPIName.substr(22);

					// On instancie un tableau qui va contenir les ids des cartes
					let arrayCardsId = [];

					// On initialise un compteur
					let cardOrder = 0;

					// On initialise une variable pour savoir si on parcourt les macros ou non
					let isMacros = false;

					// On parcourt les cartes de la liste
					listAPI.cards.map((cardAPI) => {
						// Si c'est la première carte
						if (cardOrder > 0) {
							// Si on n'a pas rencontré une macro
							if (! isMacros) {
								// On récupère le nom de la carte
								const cardName = cardAPI.name;

								// Si le nom de la carte ne contient pas - Macros -
								if (cardName.match(/- Macros -/g) === null) {
									// On ajoute l'id de la carte au tableau
									arrayCardsId.push(cardAPI.id);

									// On incrémente le compteur
									cardOrder += 1;
								} else {
									// On indique avoir rencontré les macros
									isMacros = true;
								}
							}
						} else {
							// On incrémente le compteur
							cardOrder += 1;
						}
					});

					// On ajoute le sprint à la liste avec comme clé le numéro du sprint
					objListsAPI[sprintOrder] = {
						order: sprintOrder,
						number: sprintNumber,
						name: sprintName,
						version: sprintVersion,
						apiId: listAPI.id,
						cardsId: arrayCardsId,
						numberOfCards: arrayCardsId.length,
					};

					// On incrémente le compteur
					sprintOrder += 1;
				}

				return false;
			});

			// On appelle le callback passé en paramètre
			callback(objListsAPI, elem);
		});
	}

	// Fonction permettant de mettre à jour les infos de la team
	updateTeamInfoFromBoardAPI(callback, elem) {
		// On lance la requête pour récupérer les infos des streamers depuis leur pseudo
		fetch(
			'https://api.trello.com/1/organizations/neonomadefullteam/members?key=e0edc2f7a3f1efc4115084c573964b8c&token=6392d59c2cfbb640baeb86ff97cd20a4d39c38149cde8050638ec8fae7cd75eb&fields=id,fullName,initials,avatarHash',
			{
				methode: 'GET'
			}
		)
		.then(results => {
			return results.json();
		})
		.then(data => {
			// console.log(data);

			// On instancie une variable qui va contenir les informations des développeurs
			let objDeveloppers = {};

			// On instancie une variable contenant les id des développeurs
			const objDeveloppersId = elem.state.developpersId;

			// On instancie une variable qui va contenir les informations des testeurs
			let objTesters = {};

			// On instancie une variable contenant les id des testeurs
			const objTestersId = elem.state.testersId;

			// On instancie une variable qui va contenir les informations des sous testeurs
			let objSubTesters = {};

			// On instancie une variable contenant les id des sous testeurs
			const objSubTestersId = elem.state.subTestersId;

			// On récupère la base de l'url des images de profil
			const baseUrl = 'https://trello-avatars.s3.amazonaws.com/';

			// On parcourt les membres
			data.map((member) => {
				// On créé les url des images de profil
				let avatar30 = null;
				let avatar50 = null;
				let avatar170 = null;

				// Si le membre a une image
				if (member.avatarHash !== null) {
					avatar30 = baseUrl + member.avatarHash + '/30.png';
					avatar50 = baseUrl + member.avatarHash + '/50.png';
					avatar170 = baseUrl + member.avatarHash + '/170.png';
				}

				// On ajoute ces urls au membre
				member.avatar30 = avatar30;
				member.avatar50 = avatar50;
				member.avatar170 = avatar170;

				// Si le membre est un développeur
				if (member.id in objDeveloppersId) {
					// Si le développeur doit être affiché
					if (objDeveloppersId[member.id] === true) {
						// On ajoute le développeur à notre objet global
						objDeveloppers[member.id] = member;
					}

				// Si le membre est un testeur
				} else if (member.id in objTestersId) {
					// Si le testeur doit être affiché
					if (objTestersId[member.id] === true) {
						// On ajoute le développeur à notre objet global
						objTesters[member.id] = member;
					}
				
				// Si le membre est un sous testeur
				} else if (member.id in objSubTestersId) {
					// On récupère l'id du testeur parent
					const parentTesterId = objSubTestersId[member.id].parentTester;

					// Si le sous testeur doit être affiché et que le testeur parent doit être
					if (objSubTestersId[member.id].show === true && objTestersId[parentTesterId] === true) {
						// On ajoute le sous testeur a l'objet global
						objSubTesters[member.id] = member;
					}
				}
			});

			// On construit notre objet teamInfo
			const objTeamInfo = {
				developpersInfo: objDeveloppers,
				testersInfo: objTesters,
				subTestersInfo: objSubTesters,
			};

			// On appelle le callback passé en paramètre
			callback(objTeamInfo, elem);
		});
	}


	render () {
		// On instancie un tableau contenant le jsx des sprints
		let sprintsInfoJSX = []; 

		// On parcourt les infos des sprints
		for(const sprintOrder in this.state.sprintsInfo) {
			// On ajoute le JSX du sprint
			sprintsInfoJSX.push((
				<li key={this.state.sprintsInfo[sprintOrder].apiId}
					className="pas" >
						<TsSprintItem 
							sprintInfo={this.state.sprintsInfo[sprintOrder]}
							teamInfo={this.state.teamInfo} 
						/>
				</li>
			));
		}

		return (
			<div className="mw800 m-auto">

				{/* Si on est en train de charger les données */}
				{ this.state.loading &&
					<div className="txtcenter">
						<ScaleLoader
							color={'#858383'} 
							height={14}
							width={2}
							loading={this.state.loading}
						/>
					</div>
				}

				{/* Si la liste des sprints est chargée */}
				{ sprintsInfoJSX.length > 0 &&
					<div>
						<h4 className="proxima">
							Cliquez sur un sprint pour accéder à son détail :
						</h4>

						<ul className="sprintList">
							{sprintsInfoJSX}
						</ul>
						
						<Route 
							path='/sprints/:trelloSprintId/:sprintNumber' 
							render={(props) => <TsSprintDetail
													{...props} 
													sprintsInfo={this.state.sprintsInfo}
													teamInfo={this.state.teamInfo} 
												/>
									}
						/>
					</div>
				}
			</div>
		);
	}
}

export default TsSprintList;


// WEBPACK FOOTER //
// ./src/js/TsSprintList.jsx